import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';

@Injectable()
export class SaPaypalServiceService {

  constructor(private http: HttpClient) { }
  getTransactions() {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/PayPal/getTransactions');
  }

  getProducts() {
    var reqHeader = new HttpHeaders({  'No-Auth': 'True' });
    return this.http.get(globalAdd.Paneladdress + 'api/SA/PayPal/getPaypalProducts',{headers: reqHeader});
  }

  getMoreTransactions(nextId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/PayPal/getMoreTransactions?nextId='+ nextId );
  }

  addPartner(name, emailId) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/BusinessInfo/addPartner', { name: name, emailId: emailId });
  }

  getBusinessPartnerList(){
    return this.http.get(globalAdd.Paneladdress + 'api/SA/BusinessInfo/getBusinessPartnersList');
  }

  updateBusinessPartnerDetail(id, name, emailId){
    return this.http.post(globalAdd.Paneladdress + 'api/SA/BusinessInfo/updateBusinessPartnerDetail', { id: id, name: name, emailId: emailId });
  }

  deleteBusinessPartner(id){
    return this.http.get(globalAdd.Paneladdress + 'api/SA/BusinessInfo/deleteBusinessPartner?id='+id);
  }

  checkEmailIsValid(email, partnerId) {
     return this.http.get(globalAdd.Paneladdress + 'api/SA/BusinessInfo/checkUniquePartner?email='+email+'&partnerId='+(partnerId == null ? " " : partnerId), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
   }

  getIpsTransactionss(pageNo: number, text: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/IpsTransaction/getIpsTransactions?'+'pageNo='+pageNo+'&text='+text);
  }
}
